import { render, staticRenderFns } from "./OperaChangeOrderRecordWindow.vue?vue&type=template&id=8fbfa03a&scoped=true&"
import script from "./OperaChangeOrderRecordWindow.vue?vue&type=script&lang=js&"
export * from "./OperaChangeOrderRecordWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaChangeOrderRecordWindow.vue?vue&type=style&index=0&id=8fbfa03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbfa03a",
  null
  
)

export default component.exports